module.exports = __webpack_public_path__ + "img/edu-institution-6.0afd829d.png";